import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/")({
  staticData: {
    title: "projects.title",
  },
});
